import Image, { ImageProps } from 'next/image'
import React, { useState } from 'react'

interface HotelCardImageProps extends ImageProps {
	fallbackSrc: string
}

const HotelCardImage: React.FC<HotelCardImageProps> = ({
	src,
	fallbackSrc,
	...props
}) => {
	const [imgSrc, setImgSrc] = useState(src)

	return (
		<Image
			{...props}
			src={imgSrc}
			alt={props.alt}
			fill
			sizes="(max-width: 768px) 100vw, 278px"
			quality={100}
			onError={() => {
				setImgSrc(fallbackSrc)
			}}
		/>
	)
}

export default HotelCardImage
